import { createAction } from "redux-actions";
import {
  getContentsByCustomerId,
  getQualifications,
  getWorkExperience,
} from "../api/contents";
import * as Auth from "../api/customer";
import {
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_FAILURE,
  FORGET_PASSWORD_FAILURE,
  FORGET_PASSWORD_SUCCESS,
  GET_CANDIDATE_QUALIFICATIONS_SUCCESS,
  GET_CANDIDATE_QUALIFICATIONS_FAILURE,
  GET_CANDIDATE_EXPERIENCES_SUCCESS,
  GET_CANDIDATE_EXPERIENCES_FAILURE,
  CLEAR_NOTIFICATIONS,
  GET_CANDIDATE_CERTIFICATIONS_SUCCESS,
  GET_CANDIDATE_CERTIFICATIONS_FAILURE,
  UPDATE_LOGIN_FIELD_SUCCESS,
  UPDATE_LOGIN_FIELD_FAILURE,
} from "../constants/actionTypes";
import { apiErrorHandler, isEmailVerified } from "../helpers/common";
import { CustomSnackbar } from "../helpers/CustomSnackbar";

const signUpSuccess = createAction(SIGNUP_SUCCESS);
const signUpFailure = createAction(SIGNUP_FAILURE);

export function signUp(params) {
  return (dispatch) =>
    Auth.signUp(params)
      .then((json) => {
        console.group("🧪 [ACTION] signUp Success");
        console.log("1. Request Params Passed:", params);
        console.log("2. Raw Server Response (json):", json);
        console.log("3. Extracted Response Data (json.data):", json?.data);
        console.groupEnd();

        dispatch(signUpSuccess(json));
        console.log("signUp-json::", json);

        return json; // ✅ Return complete API response
      })
      .catch((error) => {
        console.group("❌ [ACTION] signUp Error");
        console.log("1. Error Object:", error);
        console.log("2. Response Error Data:", error?.response?.data);
        console.groupEnd();

        dispatch(signUpFailure(error));

        console.log("signUp-error::", error);

        return (
          error?.response?.data || {
            success: false,
            message: "Something went wrong.",
          }
        );
      });
}

const loginSuccess = createAction(LOGIN_SUCCESS);
const loginFailure = createAction(LOGIN_FAILURE);

export { loginSuccess, loginFailure };

const updateLoginFieldSuccess = createAction(UPDATE_LOGIN_FIELD_SUCCESS);
const updateLoginFieldFailure = createAction(UPDATE_LOGIN_FIELD_FAILURE);

export { updateLoginFieldSuccess, updateLoginFieldFailure };

export function login(params, isInternalUser = false) {
  return (dispatch) =>
    Auth.login(params)
      .then((json) => {
        console.log("========== LOGIN API ==========");
        console.log("FULL RESPONSE:", json);
        console.log("RESPONSE.DATA:", json?.data);
        console.log("RESPONSE.DATA.DATA:", json?.data?.data);

        const resData = json?.data?.data;

        if (!resData) {
          console.error("❌ resData is missing");
          CustomSnackbar.error("Invalid API response");
          return json;
        }

        console.log("----------- USER DATA -----------");
        console.log("USERNAME :", resData?.username);
        console.log("NAME     :", resData?.name);
        console.log("FULLNAME :", resData?.fullName);
        console.log("EMAIL    :", resData?.email);
        console.log("PHONE    :", resData?.phoneNumber);

        // Normalize data
        const customer = {
          id: resData.userId,
          name:
            resData.fullName ||
            resData.name ||
            resData.username ||
            resData.email ||
            resData.phoneNumber,
          email: resData.email,
          phoneNumber: resData.phoneNumber,
          customer_type: params?.customer_type || 2,
          additional_fields: "{}",
        };

        console.log("----------- CUSTOMER OBJECT -----------");
        console.log(customer);

        const finalPayload = {
          customer,
          token: resData.token,
        };

        console.log("----------- FINAL PAYLOAD -----------");
        console.log(finalPayload);

        // 👇 Create action first
        const action = loginSuccess(finalPayload);

        console.log("=========== ACTION CREATED ===========");
        console.log(action);
        console.log("ACTION TYPE:", action.type);
        console.log("ACTION PAYLOAD:", action.payload);

        // 👇 Dispatch the same action
        dispatch(action);

        console.log("✅ LOGIN_SUCCESS dispatched");

        return json;
      })
      .catch((error) => {
        console.error("LOGIN ERROR:", error);

        if (error?.response?.data?.message) {
          CustomSnackbar.error(error.response.data.message);
        } else {
          CustomSnackbar.error("Something went wrong!");
        }

        dispatch(loginFailure({ error: "Invalid username or password" }));
        return false;
      });
}

const updateProfileSuccess = createAction(UPDATE_PROFILE_SUCCESS);
const updateProfileFailure = createAction(UPDATE_PROFILE_FAILURE);

export function updateProfile(params) {
  return (dispatch) =>
    Auth.updateProfile(params)
      .then((json) => {
        console.log("🔥 ACTION RESPONSE:", json);

        // ✅ THIS IS THE MAIN FIX
        dispatch(updateProfileSuccess(json));

        return json;
      })
      .catch((error) => {
        apiErrorHandler(error);
        console.log("❌ update-pro-error::", error);
        dispatch(updateProfileFailure(error));
        return error;
      });
}
export function updateProfileEmployer(params) {
  return (dispatch) =>
    Auth.updateProfileEmployer(params)
      .then((response) => {
        // Axios wraps the backend JSON inside a 'data' property
        const userData = response.data;

        console.log("🔥 FIXED ACTION RESPONSE:", userData);

        // Dispatch the actual user data, not the whole response object
        dispatch(updateProfileSuccess(userData));

        return userData;
      })
      .catch((error) => {
        apiErrorHandler(error);
        dispatch(updateProfileFailure(error));
        return error;
      });
}

const getProfileSuccess = createAction(GET_CUSTOMER_SUCCESS);
const getProfileFailure = createAction(GET_CUSTOMER_FAILURE);

export function getCustomerDetails(userId) {
  console.log("🚀 [ACTION] getCustomerDetails Triggered for ID:", userId);

  return (dispatch) =>
    Auth.getCustomerDetails(userId)
      .then((json) => {
        // 1. Check API Raw Response
        console.log("✅ [ACTION] API Response (GetDetails):", json);

        // 2. Map fields if necessary before dispatching
        // Agar API 'fullName' bhej rahi hai aur UI 'name' mang raha hai
        // In getCustomerDetails action:
        const processedData = {
          ...json,
          data: {
            ...json.data,
            // 🎯 FIX: was json.data?.fullName (wrong depth) — actual fields are one level deeper
            name:
              json.data?.data?.fullName ||
              json.data?.data?.name ||
              json.data?.data?.username ||
              "",
          },
        };

        console.log("📦 [ACTION] Dispatching to Reducer:", processedData);

        dispatch(getProfileSuccess(processedData));
        return processedData;
      })
      .catch((error) => {
        console.error("❌ [ACTION] GetDetails Error:", error);
        // Ensure you are dispatching the failure, not just calling the function
        dispatch(getProfileFailure(error));
        return error;
      });
}

const getCandidateQualificationsSuccess = createAction(
  GET_CANDIDATE_QUALIFICATIONS_SUCCESS,
);
const getCandidateQualificationsFailure = createAction(
  GET_CANDIDATE_QUALIFICATIONS_FAILURE,
);

// 🟢 FIXED: Using targeted endpoint mapper payload structure
export function getCandidateQualifications() {
  return (dispatch) =>
    getQualifications()
      .then((json) => {
        // 🟢 ALTERNATIVE FALLBACK: If 'json' is directly the server root object,
        // then the qualifications array lives directly inside json.data!
        const qualificationsArray = json?.data || [];

        console.log(
          "✈️ Redux Action Dispatching Array Target:",
          qualificationsArray,
        );

        dispatch(getCandidateQualificationsSuccess(qualificationsArray));
        return json;
      })
      .catch((error) => {
        dispatch(getCandidateQualificationsFailure(error));
        return error;
      });
}
const getCandidateExperiencesSuccess = createAction(
  GET_CANDIDATE_EXPERIENCES_SUCCESS,
);
const getCandidateExperiencesFailure = createAction(
  GET_CANDIDATE_EXPERIENCES_FAILURE,
);

// In actions.js
export function getCandidateExperiences() {
  return (dispatch) =>
    getWorkExperience() // Hits your /Experience/me endpoint
      .then((json) => {
        // 🟢 MATCHES QUALIFICATIONS: Read the array directly from json.data
        const experiencesArray = json?.data || [];

        console.log(
          "✈️ Redux Action Dispatching Experience Array Target:",
          experiencesArray,
        );

        dispatch(getCandidateExperiencesSuccess(experiencesArray));
        return json;
      })
      .catch((error) => {
        dispatch(getCandidateExperiencesFailure(error));
        return error;
      });
}

const getCandidateCertificationSuccess = createAction(
  GET_CANDIDATE_CERTIFICATIONS_SUCCESS,
);
const getCandidateCertificationFailure = createAction(
  GET_CANDIDATE_CERTIFICATIONS_FAILURE,
);

export function getCandidateCertifications(userId) {
  return (dispatch) =>
    getContentsByCustomerId("candidate_certifications", userId)
      .then((json) => {
        // 🔥 FIX: json.data.data se array nikaala
        const certificationsArray = json?.data?.data || [];

        dispatch(getCandidateCertificationSuccess(certificationsArray));
        return json;
      })
      .catch((error) => {
        // 🔥 FIX: dispatch add kiya failure action ke liye
        dispatch(getCandidateCertificationFailure(error));
        return error;
      });
}

const logoutSuccess = createAction(LOGOUT_SUCCESS);
const clearNotifications = createAction(CLEAR_NOTIFICATIONS);

export function logout(showSnackbar = true) {
  return (dispatch) => {
    dispatch(logoutSuccess());
    dispatch(clearNotifications());
    if (showSnackbar) {
      CustomSnackbar.success("Logout Successfully.");
    }
  };
}

const forgetPasswordSuccess = createAction(FORGET_PASSWORD_SUCCESS);
const forgetPasswordFailure = createAction(FORGET_PASSWORD_FAILURE);

export function forgetPassword(params) {
  return (dispatch) =>
    Auth.forgetPassword(params)
      .then((json) => {
        dispatch(forgetPasswordSuccess(json));
        // dispatch(showSuccessSnackbar(`An OTP sent to your mobile number +${params.mobile_number}`));
        return true;
      })
      .catch((error) => {
        // dispatch(showErrorSnackbar('The mobile number may be wrong!'))
        dispatch(forgetPasswordFailure(error));
        return false;
      });
}

export const getErrorMsg = (err) => {
  let msg = "Something went wrong! Please try again later!";
  if (
    err.response &&
    err.response.data &&
    err.response.data[0] &&
    err.response.data[0].message
  ) {
    msg = err.response.data[0].message;
  } else if (err.response && err.response.data && err.response.data.message) {
    msg = err.response.data.message;
  }
  return msg;
};

export function updateLoginField(params) {
  return (dispatch) => {
    // This action is dispatched after successful login field update
    // The API call is handled in the component, this just updates the store
    dispatch(updateLoginFieldSuccess(params));
    return params;
  };
}
